/* ============================================================================
   LEAGUE LIDS — FOOTER · assets/ll-footer.js
   Drop-list signup wiring. Primary capture = ops-hub subscribe API (reliable;
   fires the consent event + Newsletter list join → live Welcome flow); the
   Shopify-native /contact post fires as a best-effort consent record only —
   NEVER relied on alone (bot challenges silently eat those). ⛔ #82.

   A footer signup also sets the welcome popup's "done" flag so the popup
   never nags someone who already joined here.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-ll-footer]');
  if (!root || root.__llfInit) return;
  root.__llfInit = true;

  var APP_BASE = (root.getAttribute('data-app-base') || 'https://app.leaguelids.com').replace(/\/+$/, '');
  var form = root.querySelector('[data-llf-form]');
  if (!form) return;

  var emailInput = form.querySelector('input[name="email"]');
  var submitBtn = form.querySelector('[data-llf-submit]');
  var errorEl = form.querySelector('[data-llf-error]');
  var successEl = root.querySelector('[data-llf-success]');

  function showError(msg, suggestion) {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.appendChild(document.createTextNode(msg + ' '));
    if (suggestion) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'Did you mean ' + suggestion + '?';
      btn.addEventListener('click', function () {
        emailInput.value = suggestion;
        clearError();
        emailInput.focus();
      });
      errorEl.appendChild(btn);
    }
    errorEl.setAttribute('data-show', '');
    emailInput.setAttribute('aria-invalid', 'true');
  }
  function clearError() {
    if (!errorEl) return;
    errorEl.removeAttribute('data-show');
    errorEl.textContent = '';
    emailInput.removeAttribute('aria-invalid');
  }
  emailInput.addEventListener('input', clearError);

  function fireNativeConsent(email) {
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter,footer-form');
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) { /* best-effort only */ }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();
    var email = (emailInput.value || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    var honeypot = form.querySelector('input[name="website"]');
    submitBtn.disabled = true;

    fetch(APP_BASE + '/api/email/contacts/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        source_tag: 'footer-form',
        website: honeypot ? honeypot.value : '',
      }),
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; }).catch(function () {
          return { ok: res.ok, json: {} };
        });
      })
      .then(function (r) {
        submitBtn.disabled = false;
        if (!r.ok) {
          showError(r.json.error || 'Something went wrong. Please try again.', r.json.suggestion || null);
          return;
        }
        fireNativeConsent(email);
        form.hidden = true;
        if (successEl) successEl.hidden = false;
        // Don't let the welcome popup nag someone who just joined here.
        try { localStorage.setItem('llwp:done', '1'); } catch (err) { /* noop */ }
      })
      .catch(function () {
        submitBtn.disabled = false;
        showError('Connection hiccup. Please try again.');
      });
  });
})();
